<template>
  <v-card class="edit-recurrent-booking" height="90vh">
    <v-card-title>{{ $t('admin_acc_recurrent_booking.edit_title') }}</v-card-title>
    <v-card-text>
      <div class="edit-recurrent-booking-content" v-if="bookingRecord">
        <div class="edit-recurrent-booking-content-col left">
          <div>
            <v-text-field readonly
                          :label="$t('admin_acc_booking.reserved_at')"
                          hide-details
                          :value="$parseDate(bookingRecord.create_at)"></v-text-field>
            <v-text-field readonly
                          :label="$t('admin_acc_recurrent_booking.reference_number')"
                          hide-details
                          :value="`BV${bookingRecord.reference_number.toString().padStart(10, '0')}`"></v-text-field>
            <v-text-field readonly
                          :label="$t('admin_acc_recurrent_booking.recurrent_title')"
                          hide-details
                          :value="bookingRecord.recurrent_title"></v-text-field>
            <v-text-field readonly
                          :label="$t('admin_user.serial_no')"
                          hide-details
                          :value="bookingRecord.hkiarace_account.serial_no">
              <template #append>
                <v-btn icon
                       @click="onMemberEdit">
                  <v-icon>mdi-magnify</v-icon>
                </v-btn>
              </template>
            </v-text-field>
            <v-text-field readonly
                          :label="$t('admin_acc_member.title')"
                          hide-details
                          :value="$t('name', {given_name: bookingRecord.hkiarace_account.given_name, surname: bookingRecord.hkiarace_account.surname})"></v-text-field>
          </div>
        </div>
        <div class="edit-recurrent-booking-content-col right">
          <AdminBookingList full-height
                            hide-actions
                            :extra-filters="{'booking_record.id': [bookingRecordId]}"></AdminBookingList>
        </div>
      </div>
    </v-card-text>
    <v-card-actions>
      <v-btn color="primary"
             @click="$emit('submit')">
        {{ $t('cancel') }}
      </v-btn>
      <v-spacer></v-spacer>
    </v-card-actions>


    <EditMemberModal :shown="editMemberModalShown"
                     :account-id="editingMemberId"
                     @cancel="editMemberModalShown = false"
                     @finish="onEditMemberModalFinish"></EditMemberModal>
  </v-card>
</template>
<script>
import {onMounted, ref} from "@vue/composition-api";
import AdminBookingList from "@/components/acc_booking/booking/AdminBookingList.vue";

export default {
  name: 'EditRecurringBookingModal',
  components: {AdminBookingList, EditMemberModal: () => import('@/components/member/EditMemberModal')},
  props: {
    bookingRecordId: String,
  },
  setup(props, {root, emit}) {
    const bookingRecord = ref(null);

    const getBookingRecord = function () {
      root.$callAPI('aafb/admin/recurrent_bookings/', {booking_record_id: props.bookingRecordId}, (response) => {
        bookingRecord.value = response.body.booking_record;
      });
    }

    //
    const editingMemberId = ref(null);
    const editMemberModalShown = ref(false);
    const onMemberEdit = function () {
      editingMemberId.value = bookingRecord.value.hkiarace_account.id;
      editMemberModalShown.value = true;
    };
    const onEditMemberModalFinish = function () {
      editMemberModalShown.value = false;
    }

    onMounted(() => {
      getBookingRecord();
    })

    return {
      bookingRecord,

      editingMemberId,
      editMemberModalShown,
      onMemberEdit,
      onEditMemberModalFinish,
    }
  }
}
</script>

<style lang="less">
.edit-recurrent-booking {
  display: flex !important;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  .v-card__title, .v-card__text, .v-card__actions {
    width: 100%;
  }

  .v-card__title, .v-card__actions {
    flex: 0 0 auto;
  }

  .v-card__text {
    flex: 1 1 0;
    overflow: auto;
  }

  .edit-recurrent-booking-content {
    width: 100%;
    height: 100%;

    display: flex;
    gap: 12px;

    .edit-recurrent-booking-content-col {
      height: 100%;

      display: flex;
      flex-direction: column;
      overflow-y: auto;

      &.left {
        flex: 1 1 0;
      }

      &.right {
        flex: 2 2 0;
      }
    }
  }
}


</style>
